import React from "react";

import styled from "styled-components";

import { useWellDetailHover } from "./hooks/adapters/useWellDetailHover";

/**
 * WellDetail renders a hover tooltip on the map showing well or facility
 * metadata fields. All imperative Mapbox interactions (mouse events, feature
 * queries, debounced API fetching, overflow adjustment) are delegated to the
 * `useWellDetailHover` adapter hook.
 */
function WellDetail() {
  const { wellDetail, popupRef } = useWellDetailHover();

  if (!wellDetail.show) {
    return null;
  }

  return (
    <Wrapper ref={popupRef} left={wellDetail.x} top={wellDetail.y}>
      <Grid>
        {wellDetail.displayFields.map(({ label, value }) => (
          <React.Fragment key={label}>
            <Title hasFacility={wellDetail.isFacility}>{label}:</Title>
            <ItemInfo>{value}</ItemInfo>
          </React.Fragment>
        ))}
      </Grid>
    </Wrapper>
  );
}

export default WellDetail;

const Grid = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  align-items: flex-end;
  gap: 2px 8px;
`;

const Wrapper = styled.div`
  position: absolute;
  left: ${(props) => (props.left ? props.left : 0)}px;
  top: ${(props) => (props.top ? props.top : 0)}px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 200px;
  border-radius: 10px;
  background: radial-gradient(
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0.15) 80%,
    rgba(0, 0, 0, 0.1) 100%
  );
  backdrop-filter: blur(4px);
  color: white;
  font-family: "Open Sans", sans-serif;
  padding: 10px;
  max-width: 500px;
  margin: 0;
  z-index: 20;
  pointer-events: none;
  box-shadow: var(--shadow-drawer);
`;

const Title = styled.h5`
  font-size: 1.2rem;
  color: white;
  min-width: 100px;
  text-align: right;
  filter: drop-shadow(0 0 16px var(--color-surface-05));
  min-height: 20px;
  line-height: 1.2;
  max-width: 200px;
  align-content: center;
`;

const ItemInfo = styled.span`
  display: block;
  margin-left: 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #cdfffa;
  max-width: 220px;
  font-size: 1.2rem;
  font-weight: bold;
  filter: drop-shadow(0 0 16px var(--color-surface-05));
  align-content: center;
`;
